import { useState } from "react";

/**
 * Accessible accordion FAQ — shared by agent answer pages and homepage.
 */
export default function AgentFaq({
  faqs = [],
  id = "agent-faq",
  sectionId,
  kicker = "FAQ",
  title = (
    <>
      Frequently asked <b>questions</b>
    </>
  ),
  className = "",
}) {
  const [open, setOpen] = useState(0);

  if (!faqs.length) return null;

  return (
    <section
      id={sectionId}
      className={`page-section compact agent-faq-section ${className}`.trim()}
      aria-labelledby={`${id}-heading`}
    >
      <div className="wrap agent-faq-wrap">
        <span className="kicker">{kicker}</span>
        <h2 className="section-title agent-faq-title" id={`${id}-heading`}>
          {title}
        </h2>
        <p className="agent-faq-lede">
          Clear answers for clinicians, hospital admins, and compliance teams — structured for search and AI citations.
        </p>

        <div className="faq-list agent-faq-list">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div className="faq-item" key={f.question} data-open={isOpen}>
                <button
                  type="button"
                  className="faq-q"
                  aria-expanded={isOpen}
                  aria-controls={`${id}-a-${i}`}
                  id={`${id}-q-${i}`}
                  onClick={() => setOpen(isOpen ? null : i)}
                >
                  {f.question}
                  <span className="plus" aria-hidden="true" />
                </button>
                <div
                  className="faq-a"
                  id={`${id}-a-${i}`}
                  role="region"
                  aria-labelledby={`${id}-q-${i}`}
                >
                  <p>{f.answer}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
